
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LazyLoadImageModule } from 'ng-lazyload-image';
import { SwiperModule } from 'swiper/angular';
import { BlogComponent } from './blog.component';
import { BlogRoutingModule } from './blog-routing.module';
import { FormsModule } from '@angular/forms';
import { DestaquePostModule } from 'src/app/components/destaques-post/destaques-post.module';
import { BannerPostModule } from 'src/app/components/banner-post/banner-post.module';
import { LatestPostModule } from 'src/app/components/latestPosts/latest-post.module';
import { DestaquePostFilterModule } from 'src/app/components/destaques-post-filter/destaques-post-filter.module';
import { ModalModule } from 'src/app/components/modal/modal.module';


@NgModule({
    declarations: [
        BlogComponent,
    ],
    imports: [
        CommonModule,
        SwiperModule,
        LazyLoadImageModule,
        BlogRoutingModule,
        FormsModule,
        DestaquePostModule,
        DestaquePostFilterModule,
        BannerPostModule,
        LatestPostModule,
        ModalModule
    ]
})
export class BlogModule { }


